import { createSlice } from '@reduxjs/toolkit';
import { count } from 'console';

const ipBlockSlice = createSlice({
  name: 'ipBlockList',
  initialState: {
    ipBlocked: [],
    caseIPList: [],
    loginLogs: [],
    loginLogsCount: 0,
    caseIPEdit: null,
    count: 0,
    caseIpCount: 0,
    addUpdateSuccess: false,
    addUpdateCaseSuccess: false,
  },
  reducers: {
    fetchCaseIpsList(state, action) {
      state.caseIPList = action.payload;
    },
    fetchLoginLogsList(state, action) {
      state.loginLogs = action.payload;
    },
    fetchLoginLogsCount(state, action) {
      state.loginLogsCount = action.payload;
    },
    fetchCaseIpsById(state, action) {
      state.caseIPEdit = action.payload;
    },
    fetchIpIPsListCount(state, action) {
      state.caseIpCount = action.payload;
    },
    fetchIpBlockedList(state, action) {
      state.ipBlocked = action.payload;
    },
    fetchIpBlockedListCount(state, action) {
      state.count = action.payload;
    },
    addUpdateSuccessAction(state, action) {
      state.addUpdateSuccess = action.payload;
    },
    addUpdateCaseSuccessAction(state, action) {
      state.addUpdateCaseSuccess = action.payload;
    },
  },
});

export const { addUpdateSuccessAction, fetchLoginLogsList, fetchLoginLogsCount, fetchCaseIpsById, addUpdateCaseSuccessAction, fetchCaseIpsList,
  fetchIpIPsListCount, fetchIpBlockedListCount, fetchIpBlockedList
} = ipBlockSlice.actions;

export default ipBlockSlice.reducer;